// 網站取媒體 URL 的唯一入口（docs/MEDIA.md 規則 3）。程式碼裡不准手寫 R2 網址。
import manifest from '@/data/media-manifest.json'
export const mediaBase = manifest.base
export const mediaSet = (set) => manifest.sets?.[set] || {}
export const mediaEntry = (set, slug) => manifest.sets?.[set]?.[slug] || null
export const mediaUrl = (set, slug, kind) => manifest.sets?.[set]?.[slug]?.files?.[kind]?.url || null
